import { useLayoutEffect, useState, useEffect, useCallback } from "react";
import {
  DateBox,
  NumberBox,
  SelectBox,
  Template,
  TextBox,
} from "devextreme-react";
import DataGrid, {
  Column,
  Editing,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import { AssetSubStatus, DefaultDateFormat } from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { useLocation, useNavigate } from "react-router-dom";
import "./../../../App.css";
import Modal from "react-modal";
import moment from "moment";
import { askConfirmation, showResponseMessage } from "../../../helper/message";
import { subCategoryService } from "../../../apis/apiServices/SubCategory";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi";
import { UomService } from "../../../apis/apiServices/Uom";
import { assetSpecService } from "../../../apis/apiServices/AssetSpec";
import { assetLocationService } from "../../../apis/apiServices/AssetLocation";
import { categoryService } from "../../../apis/apiServices/Category";
import { groupService } from "../../../apis/apiServices/Group";
import e from "cors";

const now = new Date();
const year = now.getFullYear();
const month = now.getMonth() + 1;

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function AddAssetComponent() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.data);
  const [state, setState] = useState({
    isSubmitted: false,
    isSpecificationSubmitted: false,
    assetId: location.state?.stateData?.assetId ?? 0,
    assetName: location.state?.stateData?.name ?? "",
    assetDesc: location.state?.stateData?.assetDesc ?? "",
    assetSerialNo: location.state?.stateData?.assetSerial ?? "",
    groupId: location.state?.stateData?.groupId ?? 0,
    categoryId: location.state?.stateData?.categoryId ?? 0,
    subCategoryId: location.state?.stateData?.subCategoryId ?? 0,
    categoryName: location.state?.stateData?.categoryName ?? "",
    subCategoryName: location.state?.stateData?.subcategoryName ?? "",
    uomId: location.state?.stateData?.uomId ?? 9,
    assetStatusId:
      location.state?.stateData?.statusId > 0
        ? location.state?.stateData?.statusId
        : 10001,
    hsnNumber: location.state?.stateData?.hsnNumber ?? "",
    vseFleetId: location.state?.stateData?.vseFleetId ?? "",
    erpFleetId: location.state?.stateData?.erpFleetId ?? "",
    poNo: location.state?.stateData?.poNo ?? "",
    purchaseAmount: location.state?.stateData?.invoiceAmount ?? 0,
    projId: location.state?.stateData?.projId ?? 81,
    purchaseDate: location.state?.stateData?.invoiceDate
      ? location.state?.stateData?.invoiceDate
      : "",
    currencyId: location.state?.stateData?.currencyId ?? 0,
    assignedUserId: location.state?.stateData?.assignUserId ?? 0,
    assignDepartmentId: location.state?.stateData?.assignDepartmentId ?? 0,
    assignTypeId: location.state?.stateData?.assignTypeId ?? 0,
    assignTypeName: location.state?.stateData?.assignTypeName ?? "",
    custodianUserId1: location.state?.stateData?.custodianUserId1 ?? 0,
    custodian1DeptId: location.state?.stateData?.custodian1DepartmentId ?? 0,
    custodianUserId2: location.state?.stateData?.custodianUserId2 ?? 0,
    custodian2DeptId: location.state?.stateData?.custodian2DepartmentId ?? 0,
    custodianUserId3: location.state?.stateData?.custodianUserId3 ?? 0,
    custodian3DeptId: location.state?.stateData?.custodian3DepartmentId ?? 0,
    model: location.state?.stateData?.model ?? "",
    make: location.state?.stateData?.make ?? "",
    material: location.state?.stateData?.material ?? "",
    size: location.state?.stateData?.size ?? "",
    weight: location.state?.stateData?.weight ?? 0,
    skucode: location.state?.stateData?.sKuCode ?? "",
    mfgDate: location.state?.stateData?.mfgDate
      ? location.state?.stateData?.mfgDate
      : "",
    vendorId: location.state?.stateData?.vendorId ?? 0,
    isActive: location.state?.stateData?.isActive ?? true,
    rfid: location.state?.stateData?.rfId ?? "",
    assetLocationId: location.state?.stateData?.assetLocationId ?? 1,
    makeYear: location.state?.stateData?.makeYear ?? "",
    assetModelSerialNo: location.state?.stateData?.assetModelSerialNo ?? "",
    isRfId: location.state?.stateData?.isRfidApplicable ?? false,
    assetTypeId: location.state?.stateData?.assetTypeId ?? 0,
    ownershipTypeId: location.state?.stateData?.ownerTypeId ?? 0,
    ownershipTypeName: location.state?.stateData?.ownerTypeName ?? "",
    leaseNo: location.state?.stateData?.leaseNo ?? "",
    leaseDate: location.state?.stateData?.leaseDate
      ? location.state?.stateData?.leaseDate
      : "",
    assetReachedAtSite: location.state?.stateData?.assetReachedAtSite
      ? location.state?.stateData?.assetReachedAtSite
      : "",
    leaseDuration: location.state?.stateData?.leaseDuration ?? 0,
    assetLabelNo: location.state?.stateData?.assetLabelNo ?? "",
    groupId: location.state?.stateData?.groupId ?? 0,
    groupName: location.state?.stateData?.groupName ?? "",
    isSpecicationModalOpen: false,
    specificationDetailsLst: [],
    assignedVendorId: location.state?.stateData?.assignedVendorId ?? 0,
    assignedVendorName: location.state?.stateData?.assignedVendorName ?? "",
    // assignTypeId: 0,
    // assignTypeName: "",
    // assignDepartmentId: 0,
    // assignDepartmentName: "",
    // assignedUserId: 0,
    // assignUserName: "",
  });
  const [errors, setErrors] = useState({
    assetNameValidation: "",
    categoryValidation: "",
    subCategoryValidation: "",
    projectValidation: "",
    assetLocationValidation: "",
    rfidValidation: "",
    vseFleetValidation: "",
    groupValidation: "",
    assignTypeValidation: "",
    assignDepartmentValidation: "",
    assignUserValidation: "",
    assignedVendorValidation: "",
    assignedVendorNameValidation: "",
    cust1DeptValidation: "",
    cust2DeptValidation: "",
    cust3DeptValidation: "",
    cust1UserValidation: "",
    cust2UserValidation: "",
    cust3UserValidation: "",
    erpFleetValidation: "",
    ownerTypeValidation: "",
    vendorValidation: "",
    poNoValidation: "",
    purchaseDateValidation: "",
    purchasePriceValidation: "",
    workOrderNoValidation: "",
    workOrderDateValidation: "",
    workOrderDurationValidation: "",
  });
  const [categoryDropdown, setCategoryDropdown] = useState([]);
  const [subCategoryDropdown, setSubCategoryDropdown] = useState([]);
  const [groupDropdown, setGroupDropdown] = useState([]);
  const [custodian1DepartmentDropdown, setCustodian1DepartmentDropdown] =
    useState([]);
  const [custodian1UserDropdown, setCustodian1UserDropdown] = useState([]);
  const [custodian2DepartmentDropdown, setCustodian2DepartmentDropdown] =
    useState([]);
  const [custodian2UserDropdown, setCustodian2UserDropdown] = useState([]);
  const [custodian3DepartmentDropdown, setCustodian3DepartmentDropdown] =
    useState([]);
  const [custodian3UserDropdown, setCustodian3UserDropdown] = useState([]);
  const [projectDropdown, setProjectDropdown] = useState([]);
  const [assetLocationDropdown, setAssetLocationDropdown] = useState([]);
  const [uomDropdown, setUomDropdown] = useState([]);
  const [vendorDropdown, setVendorDropdown] = useState([]);
  const [makeYearDropdown, setMakeYearDropdown] = useState([]);
  const [ownerTypeDropdown, setOwnerTypeDropdown] = useState([]);
  const [assetSpecSubLst, setAssetSpecSubLst] = useState([]);
  const [assignTypeDropdown, setAssignTypeDropdown] = useState([]);
  const [assignDepartmentDropdown, setAssignDepartmentDropdown] = useState([]);
  const [assignUserDropdown, setAssignUserDropdown] = useState([]);
  const [assignedVendorDropdown, setassignedVendorDropdown] = useState([]);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `${
      location.state?.stateData?.assetId > 0
        ? `Update Asset [${location.state?.stateData?.name} (${location.state?.stateData?.assetSerial})]`
        : `Add Asset`
    }`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      if (state.assetId == 0) {
        const statusresponse = await assetService.getassetserial(year, month);
        const num = month < 10 ? "0" + month : month;
        state.assetSerialNo =
          "VSE" + "/" + year + "/" + num + "/" + statusresponse;
      }
      setTimeout(async () => {
        await getGroupDropdown();
      }, 0);
      setTimeout(async () => {
        await getCategoryDropdown(state.groupId);
      }, 0);
      setTimeout(async () => {
        await getSubCategoryDropdown(state.categoryId);
      }, 0);
      setTimeout(async () => {
        await getCustodian1DepartmentDropdown();
      }, 0);
      setTimeout(async () => {
        await getCustodian1UserDropdown(state.custodian1DeptId);
      }, 0);
      setTimeout(async () => {
        await getCustodian2DepartmentDropdown();
      }, 0);
      setTimeout(async () => {
        await getCustodian2UserDropdown(state.custodian2DeptId);
      }, 0);
      setTimeout(async () => {
        await getCustodian3DepartmentDropdown();
      }, 0);
      setTimeout(async () => {
        await getCustodian3UserDropdown(state.custodian3DeptId);
      }, 0);
      setTimeout(async () => {
        await getProjectDropdown();
      }, 0);
      setTimeout(async () => {
        await getAssetLocationDropdown(state.projId);
      }, 0);
      setTimeout(async () => {
        await getUOMDropdown();
      }, 0);
      setTimeout(async () => {
        await getVendorDropdown("", state.vendorId);
      }, 0);
      setTimeout(async () => {
        await getassignedVendorDropdown("", state.assignedVendorId);
      }, 0);
      setTimeout(async () => {
        await getMakeYearDropdown();
      }, 0);
      setTimeout(async () => {
        await getOwnerTypeDropdown();
      }, 0);
      setTimeout(async () => {
        await getAssignTypetDropdown();
      }, 0);
      setTimeout(async () => {
        await getAssignDepartmentDropdown();
      }, 0);
      setTimeout(async () => {
        await getAssignedUserDropdown(state.assignDepartmentId);
      }, 0);
      setTimeout(async () => {
        await getAssetSpecificationSubTransLst(
          state.categoryId,
          state.subCategoryId
        );
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getGroupDropdown = async () => {
    try {
      const response = await groupService.getGroupList();
      setGroupDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCategoryDropdown = async (groupId) => {
    try {
      const response = await categoryService.getCategoryList();
      setCategoryDropdown(
        response?.data?.filter((f) => f.groupId === groupId) ?? []
      );
    } catch (error) {
      console.log(error);
    }
  };

  const getSubCategoryDropdown = async (categoryId) => {
    try {
      const response = await subCategoryService.getSubCategoryList();
      setSubCategoryDropdown(
        response?.data?.filter((f) => f.categoryId === categoryId) ?? []
      );
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian1DepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setCustodian1DepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian1UserDropdown = async (custodian1DeptId) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        custodian1DeptId,
        user?.companyId
      );
      setCustodian1UserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian2DepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setCustodian2DepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian2UserDropdown = async (custodian2DeptId) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        custodian2DeptId,
        user?.companyId
      );
      setCustodian2UserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian3DepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setCustodian3DepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian3UserDropdown = async (custodian3DeptId) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        custodian3DeptId,
        user?.companyId
      );
      setCustodian3UserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssignTypetDropdown = async () => {
    try {
      const assignTypeList = [
        { id: 1, name: "Department" },
        { id: 2, name: "User" },
        { id: 3, name: "Vendor" },
      ];
      setAssignTypeDropdown(assignTypeList ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssignDepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setAssignDepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssignedUserDropdown = async (assignDepartmentId) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        assignDepartmentId,
        user?.companyId
      );
      setAssignUserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getProjectDropdown = async () => {
    try {
      let body = { companyId: user?.companyId };
      const response = await vishwamApi.getProjectList(body);
      setProjectDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetLocationDropdown = async (projId) => {
    try {
      const response = await assetLocationService.getLocationList(projId);
      setAssetLocationDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getUOMDropdown = async () => {
    try {
      const response = await UomService.getUomList();
      setUomDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const debounce = (fn, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  };

  const debouncedVendorSearch = useCallback(
    debounce((text, vendorId) => {
      getVendorDropdown(text, vendorId);
    }, 500),
    []
  );

  const getVendorDropdown = async (searchText, vendorId) => {
    try {
      // const response = await vishwamApi.getVendorList(user?.companyId);
      // setVendorDropdown(response?.data?.filter((f) => f.isActive) ?? []);
      if (vendorId > 0) {
        const response = await vishwamApi.GetVendorDropdown();
        setVendorDropdown(
          response?.data?.filter((f) => f.isActive && f.id === vendorId) ?? []
        );
      } else {
        const response = await vishwamApi.GetVendorDropdown2(searchText);
        setVendorDropdown(response?.data?.filter((f) => f.isActive) ?? []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const assignedVendorBounce = (fn, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  };

  const debouncedAssignedVendorSearch = useCallback(
    assignedVendorBounce((text, vendorId) => {
      getassignedVendorDropdown(text, vendorId);
    }, 500),
    []
  );

  const getassignedVendorDropdown = async (searchText, vendorId) => {
    try {
      // const response = await vishwamApi.getVendorList(user?.companyId);
      // setassignedVendorDropdown(
      //   response?.data?.filter((f) => f.isActive) ?? []
      // );
      if (vendorId > 0) {
        const response = await vishwamApi.GetVendorDropdown();
        setassignedVendorDropdown(
          response?.data?.filter((f) => f.isActive && f.id === vendorId) ?? []
        );
      } else {
        const response = await vishwamApi.GetVendorDropdown2(searchText);
        setassignedVendorDropdown(
          response?.data?.filter((f) => f.isActive) ?? []
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getMakeYearDropdown = async () => {
    try {
      const currentYear = year;
      const options = [];
      for (let year = currentYear; year >= currentYear - 10; year--) {
        for (let month = 0; month < 12; month++) {
          const monthNo = `${String(month + 1).padStart(2, "0")}/${year}`;
          const monthName = `${monthNames[month]}/${year}`;
          const monthYear = `${String(year)}`;
          options.push({ monthNo, monthName, monthYear });
        }
      }
      setMakeYearDropdown(options ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getOwnerTypeDropdown = async () => {
    try {
      const ownershipTypeList = [
        { id: 1, name: "Own" },
        { id: 2, name: "Hire" },
      ];
      setOwnerTypeDropdown(ownershipTypeList ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const isValidAssetData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.assetNameValidation = "";
      err.categoryValidation = "";
      err.projectValidation = "";
      err.assetLocationValidation = "";
      err.rfidValidation = "";
      err.vseFleetValidation = "";
      err.assignDepartmentValidation = "";
      err.assignUserValidation = "";
      err.assignedVendorValidation = "";
      err.assignedVendorNameValidation = "";
      err.cust1DeptValidation = "";
      err.cust2DeptValidation = "";
      err.cust3DeptValidation = "";
      err.cust1UserValidation = "";
      err.cust2UserValidation = "";
      err.cust3UserValidation = "";
      err.assignTypeValidation = "";
      err.erpFleetValidation = "";
      err.ownerTypeValidation = "";
      err.vendorValidation = "";
      err.poNoValidation = "";
      err.purchaseDateValidation = "";
      err.purchasePriceValidation = "";
      err.workOrderNoValidation = "";
      err.workOrderDateValidation = "";
      err.workOrderDurationValidation = "";

      if (!state.assetName) {
        err.assetNameValidation = "Please enter asset name.";
        isValid = false;
      }
      if (state.groupId === 0) {
        err.groupValidation = "Please select asset group.";
        isValid = false;
      }
      if (state.categoryId === 0) {
        err.categoryValidation = "Please select asset category.";
        isValid = false;
      }
      if (state.subCategoryId === 0) {
        err.subCategoryValidation = "Please select asset subcategory.";
        isValid = false;
      }
      if (state.projId === 0) {
        err.projectValidation = "Please select project.";
        isValid = false;
      }
      if (state.assetLocationId === 0) {
        err.assetLocationValidation = "Please select location.";
        isValid = false;
      }
      if (state.isRfId && !state.rfid) {
        err.rfidValidation = "Please enter barcode / rfid.";
        isValid = false;
      }

      if (state.assignTypeId === 1) {
        if (state.assignDepartmentId === 0) {
          err.assignDepartmentValidation = "Please select department.";
          isValid = false;
        }

        if (state.assignedUserId === 0) {
          err.assignUserValidation = "Please select user.";
          isValid = false;
        }
      }

      if (state.assignTypeId === 2) {
        if (state.assignDepartmentId === 0) {
          err.assignDepartmentValidation = "Please select department.";
          isValid = false;
        }

        if (state.assignedUserId === 0) {
          err.assignUserValidation = "Please select user.";
          isValid = false;
        }
      }

      // if (state.assignTypeId >= 2 && state.assignDepartmentId === 0) {
      //   err.assignDepartmentValidation = "Please select department.";
      //   isValid = false;
      // }
      // if (state.assignTypeId >= 2 && state.assignedUserId === 0) {
      //     err.assignUserValidation = "Please select user.";
      //     isValid = false;
      // }
      if (state.assignTypeId === 3) {
        if (state.assignedVendorId === 0) {
          err.assignedVendorValidation = "Please select vendor.";
          isValid = false;
        }

        if (state.assignedVendorName === "") {
          err.assignedVendorNameValidation = "Please enter vendor name.";
          isValid = false;
        }
      }
      if (!state.vseFleetId) {
        err.vseFleetValidation =
          state.assetTypeId === 1001
            ? "Please enter vse fleet id."
            : "Please enter vse asset id.";
        isValid = false;
      }

      if (state.erpFleetId === "") {
        err.erpFleetValidation = "Please enter SAP / ERP FLEET ID.";
        isValid = false;
      }
      if (state.custodian1DeptId === 0) {
        isValid = false;
        err.cust1DeptValidation = "Please select department (custodian 1).";
      }
      if (state.custodian2DeptId === 0) {
        isValid = false;
        err.cust2DeptValidation = "Please select department (custodian 2).";
      }
      if (state.custodian3DeptId === 0) {
        isValid = false;
        err.cust3DeptValidation = "Please select department (custodian 3).";
      }
      if (state.custodianUserId1 === 0) {
        isValid = false;
        err.cust1UserValidation = "Please select custodian 1.";
      }
      if (state.custodianUserId2 === 0) {
        isValid = false;
        err.cust2UserValidation = "Please select custodian 2.";
      }
      if (state.custodianUserId3 === 0) {
        isValid = false;
        err.cust3UserValidation = "Please select custodian 3.";
      }
      if (state.assignTypeId === 0) {
        isValid = false;
        err.assignTypeValidation = "Please select assign to.";
      }
      if (state.ownershipTypeId === 0) {
        isValid = false;
        err.ownerTypeValidation = "Please select owner type.";
      }
      if (state.vendorId === 0) {
        isValid = false;
        err.vendorValidation = "Please select vendor.";
      }
      if (state.ownershipTypeId === 1) {
        if (!state.poNo) {
          isValid = false;
          err.poNoValidation = "Please enter po no.";
        }
        if (!state.purchaseDate) {
          isValid = false;
          err.purchaseDateValidation = "Please select purchase date.";
        }
        if (!state.purchaseAmount || state.purchaseAmount === 0) {
          isValid = false;
          err.purchasePriceValidation = "Please enter purchase amount.";
        }
      }
      if (state.ownershipTypeId === 2) {
        if (!state.leaseNo) {
          isValid = false;
          err.workOrderNoValidation = "Please enter work order no.";
        }
        if (!state.leaseDate) {
          isValid = false;
          err.workOrderDateValidation = "Please select work order date.";
        }
        if (!state.leaseDuration || state.leaseDuration === 0) {
          isValid = false;
          err.workOrderDurationValidation = "Please enter work order duration.";
        }
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnSaveAsset = async (e, flagStatus) => {
    e.preventDefault();
    try {
      if (isValidAssetData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are You Sure Want To ${
          state.assetId === 0 ? `Add New` : `Update`
        } Asset [<b>${state?.assetName} - (${
          state?.assetSerialNo
        })</b>]?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSubmitted: true }));
        const assetTransSpec = [];
        assetSpecSubLst.forEach((item) => {
          assetTransSpec.push({
            Id: item.trnId ?? 0,
            AssetId: state.assetId ?? 0,
            AssetSpecId: item.assetSpecSubId ?? 0,
            Specification: item.specValue ?? "",
          });
        });
        let body = {
          assetId: state.assetId,
          name: state?.assetName || "",
          assetSerial: state?.assetSerialNo || "",
          categoryId: state?.categoryId || 0,
          subCategoryId: state?.subCategoryId || 0,
          uomId: state?.uomId || 0,
          statusId:
            flagStatus === 1
              ? Number(AssetSubStatus.Onboarded)
              : state.assetStatusId,
          hsnNumber: state?.hsnNumber || "",
          vseFleetid: state?.vseFleetId || "",
          erpFleetid: state?.erpFleetId || "",
          poNo: state?.poNo || "",
          assignDepartmentId: state.assignDepartmentId || 0,
          assignedId: state.assignedUserId || 0,
          custodian1DepartmentId: state.custodian1DeptId || 0,
          custodianId1: state.custodianUserId1 || 0,
          custodian2DepartmentId: state.custodian2DeptId || 0,
          custodianId2: state.custodianUserId2 || 0,
          model: state.model || "",
          make: state.make || "",
          material: state.material || "",
          weight: state.weight || 0,
          size: state.size || "",
          invoiceAmount: state.purchaseAmount || 0,
          invoiceDate: state.purchaseDate
            ? moment(state.purchaseDate)
                .format(DefaultDateFormat.SqlDateFormat)
                .toString()
            : "",
          projectId: state.projId || 0,
          rfid: state.rfid || "",
          skuCode: state.skucode || "",
          assetModelSerialNo: state.assetModelSerialNo || "",
          mfgDate: state.mfgDate
            ? moment(state.mfgDate)
                .format(DefaultDateFormat.SqlDateFormat)
                .toString()
            : "",
          isActive: state?.isActive || false,
          modifiedBy: user?.userId,
          assetDesc: state.assetDesc || "",
          assetLocationId: state.assetLocationId || 0,
          makeYear: state.makeYear || "",
          ownerTypeId: state.ownershipTypeId || 0,
          leaseNo: state.leaseNo || "",
          leaseDate: state.leaseDate
            ? moment(state.leaseDate)
                .format(DefaultDateFormat.SqlDateFormat)
                .toString()
            : "",
          assetReachedAtSite: state.assetReachedAtSite
            ? moment(state.assetReachedAtSite)
                .format(DefaultDateFormat.SqlDateFormat)
                .toString()
            : "",
          leaseDuration: state.leaseDuration || 0,
          assetLabelNo: state.assetLabelNo || "",
          vendorId: state.vendorId || 0,
          groupId: state.groupId || 0,
          assetTranSpecification: assetTransSpec,
          assetPurchaseId: 0,
          assetPurchaseSubId: 0,
          custodian3DepartmentId: state.custodian3DeptId || 0,
          custodianId3: state.custodianUserId3 || 0,
          assignedVendorId: state.assignedVendorId || 0,
          assignedVendorName: state.assignedVendorName || "",
          assignedTypeId: state.assignTypeId || 0,
          assetRequestId: 0,
        };
        const response = await assetService.addAsset(body);
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isSubmitted: false }));
        if (response?.isSuccess) {
          if (location.state === null) {
            navigate(`/Asset`);
          } else if (location.state.sourceUrl === "Inventory") {
            navigate(`/Asset`);
          } else if (location.state.sourceUrl === "OnBoarding") {
            navigate(`/NewAsset`);
          }
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSubmitted: false }));
      console.log(error);
    }
  };

  const getAssetSpecificationSubTransLst = async (
    categoryId,
    subCategoryId
  ) => {
    try {
      const response = await assetSpecService.getSpecsublist(
        categoryId,
        subCategoryId,
        state.assetId || 0
      );
      setAssetSpecSubLst(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnSaveAssetSpecification = async (e) => {
    e.preventDefault();
    try {
      let confirmationQuestion = `<span style='font-size:16px;'>Are You Sure Want To Add Asset Specification?</span>`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );
      if (!isConfirmed) return;
      setState((prev) => ({ ...prev, isSpecificationSubmitted: true }));
      let assetSpecId = await assetSpecService.getSpecId(
        state.categoryId,
        state.subCategoryId
      );
      let specDetailsList = [];
      state.specificationDetailsLst?.map((item) => {
        specDetailsList.push({
          assetSpecSubId: item.assetSpecSubId ?? 0,
          assetSpecSubName: item.assetSpecSubName ?? "",
          srNo: item.srNo ?? 0,
        });
      });
      let body = {
        assetSpecId: assetSpecId,
        categoryId: state.categoryId,
        subCategoryId: state.subCategoryId,
        assetSpecificationSubs: specDetailsList,
      };
      let response = await assetSpecService.addAssetspec(body);
      isConfirmed = await showResponseMessage(response);
      setState((prev) => ({ ...prev, isSpecificationSubmitted: false }));
      if (response?.isSuccess) {
        handleOnCloseSpecificationModal();
        await getAssetSpecificationSubTransLst(
          state.categoryId,
          state.subCategoryId
        );
        await fetchApiOnPageLoad();
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSpecificationSubmitted: false }));
      console.log(error);
    }
  };

  const handleOnCloseSpecificationModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isSpecicationModalOpen: false,
        specificationDetailsLst: [],
      }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-header p-2">
            <h3 className="mainheading mb-0">Asset Information</h3>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Asset Name&nbsp;<span className="text-danger">*</span>
                  </label>
                  <TextBox
                    name="assetName"
                    className="form-control form-control-sm"
                    height={37}
                    placeholder="Enter asset name"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    onValueChanged={(e) => {
                      let err = { ...errors };
                      err.assetNameValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        assetName: e.value ?? "",
                      }));
                    }}
                    value={state.assetName}
                  />
                  {errors.assetNameValidation && (
                    <div className="text-danger">
                      {errors.assetNameValidation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Group&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={groupDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select group"
                    name="groupDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.groupId}
                    defaultValue={state.groupId}
                    showClearButton={true}
                    disabled={
                      location.state?.stateData?.statusId ===
                      Number(AssetSubStatus.New)
                    }
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.groupValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        groupId: e?.selectedItem?.id ?? 0,
                        groupName: e?.selectedItem?.name ?? "",
                        categoryId: 0,
                        categoryName: "",
                      }));
                      setCategoryDropdown([]);
                      if (e?.selectedItem?.id > 0) {
                        await getCategoryDropdown(e?.selectedItem?.id);
                      }
                    }}
                  />
                  {errors.groupValidation && (
                    <div className="text-danger">{errors.groupValidation}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Category&nbsp;<span className="text-danger">*</span>
                  </label>
                  {/* <SelectBox
                    dataSource={
                      new DataSource({
                        store: {
                          type: "array",
                          data: categoryDropdown,
                          key: "id",
                        },
                        group: "categoryName",
                      })
                    }
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select category"
                    name="categoryDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    showClearButton={true}
                    searchEnabled={true}
                    defaultValue={state.subCategoryId}
                    value={state.subCategoryId}
                    grouped={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.categoryValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        subCategoryId: e?.selectedItem?.id ?? 0,
                        categoryId: e?.selectedItem?.categoryId ?? 0,
                        subCategoryName: e?.selectedItem?.name ?? "",
                        categoryName: e?.selectedItem?.categoryName ?? "",
                        isRfId: e?.selectedItem?.isRfId ?? false,
                        assetTypeId: e?.selectedItem?.assetTypeId ?? 0,
                      }));
                      setAssetSpecSubLst([]);
                      if (e?.selectedItem?.id > 0) {
                        await getAssetSpecificationSubTransLst(
                          e?.selectedItem?.categoryId,
                          e?.selectedItem?.id
                        );
                      }
                    }}
                  /> */}
                  <SelectBox
                    dataSource={categoryDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select category"
                    name="categoryDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.categoryId}
                    defaultValue={state.categoryId}
                    showClearButton={true}
                    disabled={
                      location.state?.stateData?.statusId ===
                      Number(AssetSubStatus.New)
                    }
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.categoryValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        categoryId: e?.selectedItem?.id ?? 0,
                        categoryName: e?.selectedItem?.name ?? "",
                        subCategoryId: 0,
                        subCategoryName: "",
                      }));
                      setSubCategoryDropdown([]);
                      if (e?.selectedItem?.id > 0) {
                        await getSubCategoryDropdown(e?.selectedItem?.id);
                      }
                    }}
                  />
                  {errors.categoryValidation && (
                    <div className="text-danger">
                      {errors.categoryValidation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Sub Category&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={subCategoryDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select sub category"
                    name="subCategoryDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.subCategoryId}
                    defaultValue={state.subCategoryId}
                    showClearButton={true}
                    disabled={
                      location.state?.stateData?.statusId ===
                      Number(AssetSubStatus.New)
                    }
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.subCategoryValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        subCategoryId: e?.selectedItem?.id ?? 0,
                        subCategoryName: e?.selectedItem?.name ?? "",
                      }));
                    }}
                  />
                  {errors.subCategoryValidation && (
                    <div className="text-danger">
                      {errors.subCategoryValidation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Project&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={projectDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select project"
                    name="projectDropdown"
                    displayExpr="projectName"
                    valueExpr="id"
                    value={state.projId}
                    defaultValue={state.projId}
                    showClearButton={true}
                    disabled={
                      location.state?.stateData?.statusId ===
                      Number(AssetSubStatus.New)
                    }
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.projectValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        projId: e?.selectedItem?.id ?? 0,
                        assetLocationId: 0,
                      }));
                      setAssetLocationDropdown([]);
                      await getAssetLocationDropdown(e?.selectedItem?.id ?? 0);
                    }}
                  />
                  {errors.projectValidation && (
                    <div className="text-danger">
                      {errors.projectValidation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Location&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={assetLocationDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select location"
                    name="assetLocationDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.assetLocationId}
                    defaultValue={state.assetLocationId}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.assetLocationValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        assetLocationId: e?.selectedItem?.id ?? 0,
                      }));
                    }}
                  />
                  {errors.assetLocationValidation && (
                    <div className="text-danger">
                      {errors.assetLocationValidation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="form-group mb-2">
                  <label>Description</label>
                  <TextBox
                    name="assetDesc"
                    height={37}
                    className="form-control form-control-sm"
                    placeholder="Enter description"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    onValueChanged={(e) => {
                      setState((prev) => ({
                        ...prev,
                        assetDesc: e.value ?? "",
                      }));
                    }}
                    value={state.assetDesc}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>Asset Label No</label>
                  <TextBox
                    name="assetLabelNo"
                    height={37}
                    className="form-control form-control-sm"
                    placeholder="Enter asset label no"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    onValueChanged={(e) => {
                      setState((prev) => ({
                        ...prev,
                        assetLabelNo: e.value ?? "",
                      }));
                    }}
                    value={state.assetLabelNo}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header p-2">
            <h3 className="mainheading mb-0">Specifications</h3>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-lg-8">
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <div className="form-group mb-2">
                      <label>Brand / Make</label>
                      <TextBox
                        name="make"
                        height={37}
                        className="form-control form-control-sm"
                        placeholder="Enter make"
                        showClearButton={true}
                        valueChangeEvent="keyup"
                        onValueChanged={(e) => {
                          setState((prev) => ({
                            ...prev,
                            make: e.value ?? "",
                          }));
                        }}
                        value={state.make}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="form-group mb-2">
                      <label>Make Year</label>
                      <SelectBox
                        dataSource={makeYearDropdown}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select make year"
                        name="makeYearDropdown"
                        displayExpr="monthName"
                        valueExpr="monthNo"
                        value={state.makeYear}
                        defaultValue={state.makeYear}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                        onSelectionChanged={async (e) => {
                          setState((prev) => ({
                            ...prev,
                            makeYear: e?.selectedItem?.monthNo ?? "",
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="form-group mb-2">
                      <label>Model</label>
                      <TextBox
                        name="model"
                        height={37}
                        className="form-control form-control-sm"
                        placeholder="Enter model"
                        showClearButton={true}
                        valueChangeEvent="keyup"
                        onValueChanged={(e) => {
                          setState((prev) => ({
                            ...prev,
                            model: e.value ?? "",
                          }));
                        }}
                        value={state.model}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="form-group mb-2">
                      <label>
                        {state.assetTypeId === 1001
                          ? "Registration No"
                          : "Serial No"}
                      </label>
                      <TextBox
                        name="assetModelSerialNo"
                        height={37}
                        className="form-control form-control-sm"
                        placeholder={`${
                          state.assetTypeId === 1001
                            ? "Enter registration no"
                            : "Enter serial no"
                        }`}
                        showClearButton={true}
                        valueChangeEvent="keyup"
                        onValueChanged={(e) => {
                          setState((prev) => ({
                            ...prev,
                            assetModelSerialNo: e.value ?? "",
                          }));
                        }}
                        value={state.assetModelSerialNo}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6" style={{ display: "none" }}>
                    <div className="form-group mb-2">
                      <label>Weight</label>
                      <NumberBox
                        name="weight"
                        height={37}
                        className="form-control form-control-sm"
                        placeholder="Enter weight"
                        showClearButton={true}
                        valueChangeEvent="keyup"
                        onValueChanged={(e) => {
                          setState((prev) => ({
                            ...prev,
                            weight: e.value ?? 0,
                          }));
                        }}
                        value={Number(state.weight ?? 0) || ""}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6" style={{ display: "none" }}>
                    <div className="form-group mb-2">
                      <label>UOM</label>
                      <SelectBox
                        dataSource={uomDropdown}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select uom"
                        name="uomDropdown"
                        displayExpr="name"
                        valueExpr="id"
                        value={state.uomId}
                        defaultValue={state.uomId}
                        showClearButton={true}
                        disabled={true}
                        searchEnabled={true}
                        onSelectionChanged={async (e) => {
                          setState((prev) => ({
                            ...prev,
                            uomId: e?.selectedItem?.id ?? 0,
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="form-group mb-2">
                      <label>
                        {state.assetTypeId === 1001
                          ? "VSE FLEET ID"
                          : "VSE ASSET ID"}
                        &nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <TextBox
                        name="vseFleetId"
                        height={37}
                        className="form-control form-control-sm"
                        placeholder={
                          state.assetTypeId === 1001
                            ? "Enter vse fleet id"
                            : "Enter vse asset id"
                        }
                        showClearButton={true}
                        valueChangeEvent="keyup"
                        onValueChanged={(e) => {
                          let err = { ...errors };
                          err.vseFleetValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            vseFleetId: e.value ?? "",
                          }));
                        }}
                        value={state.vseFleetId}
                      />
                      {errors.vseFleetValidation && (
                        <div className="text-danger">
                          {errors.vseFleetValidation}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="form-group mb-2">
                      <label>
                        {state.assetTypeId === 1001
                          ? "SAP / ERP FLEET ID"
                          : "SAP / ERP ASSET ID"}
                      </label>
                      &nbsp;<span className="text-danger">*</span>
                      <TextBox
                        name="erpFleetId"
                        height={37}
                        className="form-control form-control-sm"
                        placeholder={
                          state.assetTypeId === 1001
                            ? "Enter sap / erp fleet id"
                            : "Enter sap / erp asset id"
                        }
                        showClearButton={true}
                        valueChangeEvent="keyup"
                        onValueChanged={(e) => {
                          let err = { ...errors };
                          err.erpFleetValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            erpFleetId: e.value ?? "",
                          }));
                        }}
                        value={state.erpFleetId}
                      />
                      {errors.erpFleetValidation && (
                        <div className="text-danger">
                          {errors.erpFleetValidation}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="form-group mb-2">
                      <label>Size / Dimension</label>
                      <TextBox
                        name="size"
                        height={37}
                        className="form-control form-control-sm"
                        placeholder="Enter size / dimension"
                        showClearButton={true}
                        valueChangeEvent="keyup"
                        onValueChanged={(e) => {
                          setState((prev) => ({
                            ...prev,
                            size: e.value ?? "",
                          }));
                        }}
                        value={state.size}
                      />
                    </div>
                  </div>
                  {state.isRfId && (
                    <>
                      <div className="col-12 col-lg-6">
                        <div className="form-group mb-2">
                          <label>
                            Barcode / RFID&nbsp;
                            <span className="text-danger">*</span>
                          </label>
                          <TextBox
                            name="rfid"
                            height={37}
                            className="form-control form-control-sm"
                            placeholder="Enter barcode / rfid"
                            showClearButton={true}
                            valueChangeEvent="keyup"
                            onValueChanged={(e) => {
                              let err = { ...errors };
                              err.rfidValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                rfid: e.value ?? "",
                              }));
                            }}
                            value={state.rfid}
                          />
                          {errors.rfidValidation && (
                            <div className="text-danger">
                              {errors.rfidValidation}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <div className="row">
                  <div className="col-12 col-lg-12">
                    <div className="form-group mb-0">
                      <label>Additional Specification</label>
                    </div>
                  </div>
                  <div className="col-12 col-lg-12">
                    <div className="form-group mb-2">
                      <DataGrid
                        dataSource={assetSpecSubLst}
                        columnAutoWidth={true}
                        showColumnLines={true}
                        showRowLines={true}
                        allowEditing={true}
                        showBorders={true}
                        rowAlternationEnabled={false}
                        allowColumnResizing={true}
                        columnResizingMode="widget"
                        height={245}
                        // onToolbarPreparing={(e) => {
                        //   e.toolbarOptions.items.unshift(
                        //     {
                        //       location: "after",
                        //       template: "toolbarAddTemplate",
                        //     },
                        //     {
                        //       location: "before",
                        //       template: "toolbarHeaderTemplate",
                        //     }
                        //   );
                        // }}
                      >
                        <Editing
                          mode="cell"
                          allowUpdating={true}
                          allowDeleting={false}
                          allowAdding={false}
                        />
                        <Column
                          dataField="assetSpecSubName"
                          caption="Name"
                          allowEditing={false}
                        />
                        <Column
                          dataField="specValue"
                          caption="Value"
                          allowEditing={true}
                        />
                        {/* <Template
                      name="toolbarAddTemplate"
                      render={() => {
                        return (
                          <>
                            <button
                              style={{ cursor: "pointer" }}
                              type="button"
                              title="Add Row"
                              className="btn btn-primary btn-sm mr-1"                             
                              onClick={() => {
                                try {
                                  setState((prev) => ({
                                    ...prev,
                                    isSpecicationModalOpen: true,
                                  }));
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                            >
                              <span title="Add">
                                <i className="fas fa-plus"></i>
                                &nbsp;&nbsp;Add
                              </span>
                            </button>
                          </>
                        );
                      }}
                    /> */}
                        {/* <Template
                          name="toolbarHeaderTemplate"
                          render={() => {
                            return (
                              <>
                                <br />
                                <h6>
                                  <b>Additional Specification</b>
                                </h6>
                              </>
                            );
                          }}
                        /> */}
                        <Scrolling mode="virtual" />
                      </DataGrid>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header p-2">
            <h3 className="mainheading mb-0">Custodian Information</h3>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Department (Custodian 1)&nbsp;
                    <span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    // dataSource={custodian1DepartmentDropdown?.filter(
                    //   (f) =>
                    //     f.id !== state.custodian2DeptId &&
                    //     f.id !== state.custodian3DeptId
                    // )}
                    dataSource={custodian1DepartmentDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select department"
                    name="custodian1DepartmentDropdown"
                    displayExpr="departmentName"
                    valueExpr="id"
                    value={state.custodian1DeptId}
                    defaultValue={state.custodian1DeptId}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.cust1DeptValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        custodian1DeptId: e?.selectedItem?.id ?? 0,
                        custodianUserId1: 0,
                      }));
                      setCustodian1UserDropdown([]);
                      if (e?.selectedItem?.id > 0) {
                        await getCustodian1UserDropdown(e?.selectedItem?.id);
                      }
                    }}
                  />
                  {errors.cust1DeptValidation && (
                    <div className="text-danger">
                      {errors.cust1DeptValidation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Custodian 1&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    // dataSource={custodian1UserDropdown?.filter(
                    //   (f) =>
                    //     f.id !== state.custodianUserId2 &&
                    //     f.id !== state.custodianUserId3
                    // )}
                    dataSource={custodian1UserDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select custodian 1"
                    name="custodian1UserDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.custodianUserId1}
                    defaultValue={state.custodianUserId1}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.cust1UserValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        custodianUserId1: e?.selectedItem?.id ?? 0,
                      }));
                    }}
                  />
                  {errors.cust1UserValidation && (
                    <div className="text-danger">
                      {errors.cust1UserValidation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Department (Custodian 2)&nbsp;
                    <span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    // dataSource={custodian2DepartmentDropdown?.filter(
                    //   (f) =>
                    //     f.id !== state.custodian1DeptId &&
                    //     f.id !== state.custodian3DeptId
                    // )}
                    dataSource={custodian2DepartmentDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select department"
                    name="custodian2DepartmentDropdown"
                    displayExpr="departmentName"
                    valueExpr="id"
                    value={state.custodian2DeptId}
                    defaultValue={state.custodian2DeptId}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.cust2DeptValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        custodian2DeptId: e?.selectedItem?.id ?? 0,
                        custodianUserId2: 0,
                      }));
                      setCustodian2UserDropdown([]);
                      if (e?.selectedItem?.id > 0) {
                        await getCustodian2UserDropdown(e?.selectedItem?.id);
                      }
                    }}
                  />
                  {errors.cust2DeptValidation && (
                    <div className="text-danger">
                      {errors.cust2DeptValidation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Custodian 2&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    // dataSource={custodian2UserDropdown?.filter(
                    //   (f) =>
                    //     f.id !== state.custodianUserId1 &&
                    //     f.id !== state.custodianUserId3
                    // )}
                    dataSource={custodian2UserDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select custodian 2"
                    name="custodian2UserDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.custodianUserId2}
                    defaultValue={state.custodianUserId2}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.cust2UserValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        custodianUserId2: e?.selectedItem?.id ?? 0,
                      }));
                    }}
                  />
                  {errors.cust2UserValidation && (
                    <div className="text-danger">
                      {errors.cust2UserValidation}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Department (Custodian 3)&nbsp;
                    <span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    // dataSource={custodian3DepartmentDropdown?.filter(
                    //   (f) =>
                    //     f.id !== state.custodian1DeptId &&
                    //     f.id !== state.custodian2DeptId
                    // )}
                    dataSource={custodian3DepartmentDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select department"
                    name="custodian3DepartmentDropdown"
                    displayExpr="departmentName"
                    valueExpr="id"
                    value={state.custodian3DeptId}
                    defaultValue={state.custodian3DeptId}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.cust3DeptValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        custodian3DeptId: e?.selectedItem?.id ?? 0,
                        custodianUserId3: 0,
                      }));
                      setCustodian3UserDropdown([]);
                      if (e?.selectedItem?.id > 0) {
                        await getCustodian3UserDropdown(e?.selectedItem?.id);
                      }
                    }}
                  />
                  {errors.cust3DeptValidation && (
                    <div className="text-danger">
                      {errors.cust3DeptValidation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Custodian 3&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    // dataSource={custodian3UserDropdown?.filter(
                    //   (f) =>
                    //     f.id !== state.custodianUserId1 &&
                    //     f.id !== state.custodianUserId2
                    // )}
                    dataSource={custodian3UserDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select custodian 3"
                    name="custodian3UserDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.custodianUserId3}
                    defaultValue={state.custodianUserId3}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.cust3UserValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        custodianUserId3: e?.selectedItem?.id ?? 0,
                      }));
                    }}
                  />
                  {errors.cust3UserValidation && (
                    <div className="text-danger">
                      {errors.cust3UserValidation}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Assign To&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={assignTypeDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select assign type"
                    name="assignTypeDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.assignTypeId}
                    defaultValue={state.assignTypeId}
                    showClearButton={true}
                    disabled={false}
                    readOnly={
                      state.rowData?.assignDepartmentId > 0 ||
                      state.rowData?.assignedUserId > 0
                        ? true
                        : false
                    }
                    searchEnabled={true}
                    onSelectionChanged={(e) => {
                      let err = { ...errors };
                      err.assignTypeValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        assignTypeId: e?.selectedItem?.id ?? 0,
                        assignTypeName: e?.selectedItem?.name ?? "",
                        assignDepartmentId: 0,
                        assignDepartmentName: "",
                        assignedUserId: 0,
                        assignUserName: "",
                      }));
                    }}
                  />
                  {errors.assignTypeValidation && (
                    <div className="text-danger">
                      {errors.assignTypeValidation}
                    </div>
                  )}
                </div>
              </div>

              {(state.assignTypeId === 1 || state.assignTypeId === 2) > 0 && (
                <>
                  <div
                    className={`col-12 col-lg-${
                      state.assignTypeId === 1 ? "3" : "3"
                    }`}
                  >
                    <div className="form-group mb-2">
                      <label>
                        Department
                        {state.assignDepartmentId === 0 && (
                          <>
                            &nbsp;<span className="text-danger">*</span>
                          </>
                        )}
                      </label>
                      <SelectBox
                        dataSource={assignDepartmentDropdown}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select department"
                        name="assignDepartmentDropdown"
                        displayExpr="departmentName"
                        valueExpr="id"
                        value={state.assignDepartmentId}
                        defaultValue={state.assignDepartmentId}
                        showClearButton={true}
                        readOnly={
                          state.rowData?.assignDepartmentId > 0 ? true : false
                        }
                        searchEnabled={true}
                        onSelectionChanged={async (e) => {
                          let err = { ...errors };
                          err.assignDepartmentValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            assignDepartmentId: e?.selectedItem?.id ?? 0,
                            assignDepartmentName:
                              e?.selectedItem?.departmentName ?? "",
                            assignedUserId: 0,
                            assignUserName: "",
                          }));
                          setAssignUserDropdown([]);
                          if (e?.selectedItem?.id > 0) {
                            await getAssignedUserDropdown(e?.selectedItem?.id);
                          }
                        }}
                      />
                      {errors.assignDepartmentValidation && (
                        <div className="text-danger">
                          {errors.assignDepartmentValidation}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}

              {(state.assignTypeId === 3) > 0 && (
                <>
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>Vendor</label>
                      <SelectBox
                        dataSource={assignedVendorDropdown}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select vendor"
                        name="assignedVendorDropdown"
                        displayExpr="name"
                        valueExpr="id"
                        value={state.assignedVendorId}
                        defaultValue={state.assignedVendorId}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                        onInput={(e) => {
                          const searchText = e?.event?.target?.value || "";
                          debouncedAssignedVendorSearch(searchText, 0);
                        }}
                        onSelectionChanged={async (e) => {
                          let err = { ...errors };
                          err.assignedVendorValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            assignedVendorId: e?.selectedItem?.id ?? 0,
                          }));
                        }}
                      />
                      {errors.assignedVendorValidation && (
                        <div className="text-danger">
                          {errors.assignedVendorValidation}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>Vendor Name&nbsp;</label>
                      <TextBox
                        name="assignedVendorName"
                        className="form-control form-control-sm"
                        height={37}
                        placeholder="Enter vendor name"
                        showClearButton={true}
                        valueChangeEvent="keyup"
                        onValueChanged={(e) => {
                          let err = { ...errors };
                          err.assignedVendorNameValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            assignedVendorName: e.value ?? "",
                          }));
                        }}
                        value={state.assignedVendorName}
                      />
                      {errors.assignedVendorNameValidation && (
                        <div className="text-danger">
                          {errors.assignedVendorNameValidation}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}

              {(state.assignTypeId === 1 || state.assignTypeId === 2) && (
                <>
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        User
                        {state.assignedUserId === 0 && (
                          <>
                            &nbsp;<span className="text-danger">*</span>
                          </>
                        )}
                      </label>
                      <SelectBox
                        dataSource={assignUserDropdown}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select user"
                        name="assignUserDropdown"
                        displayExpr="name"
                        valueExpr="id"
                        value={state.assignedUserId}
                        defaultValue={state.assignedUserId}
                        showClearButton={true}
                        readOnly={
                          state.rowData?.assignedUserId > 0 ? true : false
                        }
                        searchEnabled={true}
                        onSelectionChanged={async (e) => {
                          let err = { ...errors };
                          err.assignUserValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            assignedUserId: e?.selectedItem?.id ?? 0,
                            assignUserName: e?.selectedItem?.name ?? "",
                          }));
                        }}
                      />
                      {errors.assignUserValidation && (
                        <div className="text-danger">
                          {errors.assignUserValidation}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header p-2">
            <h3 className="mainheading mb-0">Purchase Information</h3>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Owner Type&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={ownerTypeDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select owner type"
                    name="ownerTypeDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.ownershipTypeId}
                    defaultValue={state.ownershipTypeId}
                    showClearButton={true}
                    disabled={
                      location.state?.stateData?.statusId ===
                      Number(AssetSubStatus.New)
                    }
                    searchEnabled={true}
                    onSelectionChanged={(e) => {
                      let err = { ...errors };
                      err.ownerTypeValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        ownershipTypeId: e?.selectedItem?.id ?? 0,
                        ownershipTypeName: e?.selectedItem?.name ?? "",
                        poNo: "",
                        purchaseDate: "",
                        purchaseAmount: 0,
                        leaseNo: "",
                        leaseDate: "",
                        leaseDuration: 0,
                        vendorId: 0,
                      }));
                    }}
                  />
                  {errors.ownerTypeValidation && (
                    <div className="text-danger">
                      {errors.ownerTypeValidation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>
                    Vendor&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={vendorDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select vendor"
                    name="vendorDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.vendorId}
                    defaultValue={state.vendorId}
                    showClearButton={true}
                    disabled={
                      location.state?.stateData?.statusId ===
                      Number(AssetSubStatus.New)
                    }
                    searchEnabled={true}
                    onInput={(e) => {
                      const searchText = e?.event?.target?.value || "";
                      debouncedVendorSearch(searchText, 0);
                    }}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.vendorValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        vendorId: e?.selectedItem?.id ?? 0,
                      }));
                    }}
                  />
                  {errors.vendorValidation && (
                    <div className="text-danger">{errors.vendorValidation}</div>
                  )}
                </div>
              </div>
              {state.ownershipTypeId === 1 && (
                <>
                  <div className="col-12 col-lg-2">
                    <div className="form-group mb-2">
                      <label>
                        PO No&nbsp;<span className="text-danger">*</span>
                      </label>
                      <TextBox
                        name="poNo"
                        height={37}
                        className="form-control form-control-sm"
                        placeholder="Enter po no"
                        disabled={
                          location.state?.stateData?.statusId ===
                          Number(AssetSubStatus.New)
                        }
                        showClearButton={true}
                        valueChangeEvent="keyup"
                        onValueChanged={(e) => {
                          let err = { ...errors };
                          err.poNoValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            poNo: e.value ?? "",
                          }));
                        }}
                        value={state.poNo}
                      />
                      {errors.poNoValidation && (
                        <div className="text-danger">
                          {errors.poNoValidation}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-2">
                    <div className="form-group mb-2">
                      <label>
                        Purchase Date&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <DateBox
                        type="date"
                        className="form-control"
                        name="purchaseDate"
                        placeholder={DefaultDateFormat.GridDateFormat}
                        displayFormat={DefaultDateFormat.GridDateFormat}
                        showAnalogClock={false}
                        useMaskBehavior={false}
                        defaultValue={state.purchaseDate}
                        value={state.purchaseDate}
                        disabled={
                          location.state?.stateData?.statusId ===
                          Number(AssetSubStatus.New)
                        }
                        acceptCustomValue={true}
                        onValueChanged={(date) => {
                          let err = { ...errors };
                          err.purchaseDateValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            purchaseDate: date.value,
                          }));
                        }}
                      />
                      {errors.purchaseDateValidation && (
                        <div className="text-danger">
                          {errors.purchaseDateValidation}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-2">
                    <div className="form-group mb-2">
                      <label>
                        Purchase Value [Ex. GST]&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <NumberBox
                        name="purchaseAmount"
                        height={37}
                        className="form-control form-control-sm"
                        placeholder="Enter purchase price"
                        disabled={
                          location.state?.stateData?.statusId ===
                          Number(AssetSubStatus.New)
                        }
                        showClearButton={true}
                        valueChangeEvent="keyup"
                        onValueChanged={(e) => {
                          let err = { ...errors };
                          err.purchasePriceValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            purchaseAmount: e.value ?? 0,
                          }));
                        }}
                        value={Number(state.purchaseAmount ?? 0) || ""}
                      />
                      {errors.purchasePriceValidation && (
                        <div className="text-danger">
                          {errors.purchasePriceValidation}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
              {state.ownershipTypeId === 2 && (
                <>
                  <div className="col-12 col-lg-2">
                    <div className="form-group mb-2">
                      <label>
                        Work Order No&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <TextBox
                        name="leaseNo"
                        height={37}
                        className="form-control form-control-sm"
                        placeholder="Enter work order no"
                        showClearButton={true}
                        valueChangeEvent="keyup"
                        onValueChanged={(e) => {
                          let err = { ...errors };
                          err.workOrderNoValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            leaseNo: e.value ?? "",
                          }));
                        }}
                        value={state.leaseNo}
                      />
                      {errors.workOrderNoValidation && (
                        <div className="text-danger">
                          {errors.workOrderNoValidation}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-2">
                    <div className="form-group mb-2">
                      <label>
                        Work Order Date&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <DateBox
                        type="date"
                        className="form-control"
                        name="leaseDate"
                        placeholder={DefaultDateFormat.GridDateFormat}
                        displayFormat={DefaultDateFormat.GridDateFormat}
                        showAnalogClock={false}
                        useMaskBehavior={false}
                        defaultValue={state.leaseDate}
                        value={state.leaseDate}
                        disabled={false}
                        acceptCustomValue={true}
                        onValueChanged={(date) => {
                          let err = { ...errors };
                          err.workOrderDateValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            leaseDate: date.value,
                          }));
                        }}
                      />
                      {errors.workOrderDateValidation && (
                        <div className="text-danger">
                          {errors.workOrderDateValidation}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-2">
                    <div className="form-group mb-2">
                      <label>
                        Work Order Duration&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <NumberBox
                        name="leaseDuration"
                        height={37}
                        className="form-control form-control-sm"
                        placeholder="Enter work order duration"
                        showClearButton={true}
                        valueChangeEvent="keyup"
                        onValueChanged={(e) => {
                          let err = { ...errors };
                          err.workOrderDurationValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            leaseDuration: e.value ?? 0,
                          }));
                        }}
                        value={Number(state.leaseDuration ?? 0) || ""}
                      />
                      {errors.workOrderDurationValidation && (
                        <div className="text-danger">
                          {errors.workOrderDurationValidation}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label>Asset Reached At Site</label>
                  <DateBox
                    type="date"
                    className="form-control"
                    name="leaseDate"
                    placeholder="Enter asset reached at site date"
                    displayFormat={DefaultDateFormat.GridDateFormat}
                    showAnalogClock={false}
                    useMaskBehavior={false}
                    defaultValue={state.assetReachedAtSite}
                    value={state.assetReachedAtSite}
                    disabled={false}
                    acceptCustomValue={true}
                    onValueChanged={(date) => {
                      setState((prev) => ({
                        ...prev,
                        assetReachedAtSite: date.value,
                      }));
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnSaveAsset(e, 0);
            }}
            disabled={state.isSubmitted}
          >
            <span title="Save">
              <i
                className={`fas fa-${
                  state.isSubmitted ? "spinner fa-spin" : "check"
                }`}
              />
              &nbsp;&nbsp;Save
            </span>
          </button>
          &nbsp;&nbsp;
          {location.state?.stateData?.statusId ===
            Number(AssetSubStatus.PendingForAcknowledgement) && (
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={async (e) => {
                await handleOnSaveAsset(e, 1);
              }}
              disabled={state.isSubmitted}
            >
              <span title="Save & Approve">
                <i
                  className={`fas fa-${
                    state.isSubmitted ? "spinner fa-spin" : "check"
                  }`}
                />
                &nbsp;&nbsp;Save & Approve
              </span>
            </button>
          )}
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              navigate(location.state.sourceUrl === "OnBoarding" ? "/NewAsset" : "/Asset");
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </div>

      {/* For Adding Specification */}
      <Modal
        ariaHideApp={false}
        isOpen={state.isSpecicationModalOpen}
        onAfterOpen={async () => {
          let assetSpecId = await assetSpecService.getSpecId(
            state.categoryId,
            state.subCategoryId
          );
          const response = await assetSpecService.getSpecsub(assetSpecId);
          setState((prev) => ({
            ...prev,
            specificationDetailsLst: response?.data ?? [],
          }));
        }}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Add/Edit Asset Specification"
      >
        <div className="modal-header">
          <h6 className="modal-title">Add / Edit Asset Specification</h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseSpecificationModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-gorup mb-2">
                <DataGrid
                  dataSource={state.specificationDetailsLst}
                  showColumnLines={true}
                  showRowLines={true}
                  showBorders={true}
                  allowAdding={true}
                  allowUpdating={true}
                  allowDeleting={true}
                  allowColumnResizing={true}
                  allowColumnReordering={true}
                  columnAutoWidth={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift(
                      {
                        location: "after",
                        template: "toolbarAddTemplate",
                      },
                      {
                        location: "before",
                        template: "toolbarCategoryTemplate",
                      }
                    );
                  }}
                  height={200}
                >
                  <Editing
                    mode="cell"
                    allowUpdating={true}
                    allowAdding={false}
                    allowDeleting={true}
                    useIcons={true}
                    startEditAction="click"
                  />
                  <Column
                    dataField="srNo"
                    caption="Seq. No."
                    alignment={"center"}
                    allowSearch={false}
                    allowEditing={false}
                    width={100}
                  />
                  <Column
                    dataField="assetSpecSubName"
                    caption="Name"
                    allowSearch={true}
                  />
                  <Template
                    name="toolbarAddTemplate"
                    render={() => {
                      return (
                        <>
                          <button
                            style={{ cursor: "pointer" }}
                            type="button"
                            title="Add Row"
                            className="btn btn-primary btn-sm mr-1"
                            onClick={(e) => {
                              e.preventDefault();
                              try {
                                setState((prev) => {
                                  const existingList =
                                    prev.specificationDetailsLst || [];
                                  const maxSrNo =
                                    existingList.length > 0
                                      ? Math.max(
                                          ...existingList.map(
                                            (item) => item.srNo || 0
                                          )
                                        )
                                      : 0;
                                  const newRow = {
                                    tempId: Date.now(),
                                    assetSpecSubId: 0,
                                    srNo: maxSrNo + 1,
                                    assetSpecSubName: "",
                                  };
                                  return {
                                    ...prev,
                                    specificationDetailsLst: [
                                      ...existingList,
                                      newRow,
                                    ],
                                  };
                                });
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                          >
                            <span title="Add">
                              <i className="fas fa-plus"></i>
                              &nbsp;&nbsp;Add
                            </span>
                          </button>
                        </>
                      );
                    }}
                  />
                  <Template
                    name="toolbarCategoryTemplate"
                    render={() => {
                      return (
                        <>
                          {state.categoryName ? (
                            <p className="mb-0 textinfo">
                              <b>{state.categoryName}</b>&nbsp;&nbsp;{">>"}
                              &nbsp;&nbsp; <em>{state.subCategoryName}</em>
                            </p>
                          ) : (
                            ""
                          )}
                        </>
                      );
                    }}
                  />
                  <SearchPanel
                    visible={false}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Scrolling mode="virtual" />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnSaveAssetSpecification(e);
            }}
            disabled={state.isSpecificationSubmitted}
          >
            <span title="Submit">
              <i
                className={`fas fa-${
                  state.isSpecificationSubmitted ? "spinner fa-spin" : "check"
                }`}
              />
              &nbsp;&nbsp;Submit
            </span>
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseSpecificationModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>
    </>
  );
}
